import { ActivatedRoute, ActivatedRouteSnapshot, Data, Params } from '@angular/router';

export class ActivatedRouteHelper {
  public static readAllParams(activatedRoute: ActivatedRoute): Params {
    const root: ActivatedRouteSnapshot = activatedRoute.snapshot.root;

    return ActivatedRouteHelper.readRouteParams(root);
  }

  public static readAllData(activatedRoute: ActivatedRoute): Data {
    const root: ActivatedRouteSnapshot = activatedRoute.snapshot.root;

    return ActivatedRouteHelper.readRouteData(root);
  }

  public static readRouteParams(route: ActivatedRouteSnapshot): Params {
    const childrenParams: Params = route.children.reduce(
      (merged: Params, child: ActivatedRouteSnapshot) => Object.assign(merged, ActivatedRouteHelper.readRouteParams(child)),
      {}
    );

    return Object.assign({}, route.params, childrenParams);
  }

  public static readRouteData(route: ActivatedRouteSnapshot): Data {
    const childrenData: Data = route.children.reduce(
      (merged: Data, child: ActivatedRouteSnapshot) => Object.assign(merged, ActivatedRouteHelper.readRouteData(child)),
      {}
    );

    return Object.assign({}, route.data, childrenData);
  }
}
